// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__kr50p","point":"Summary_point__aqKbL","score":"Summary_score__nQfpy","badge":"Summary_badge__OjppE"};